export default {
  WIND: '1',
  FORECAST: '2',
  NOWCAST: '3',
  RADAR: '5',
  BRIEFINGS: '11',
  SATELLITE: '6',
  GENERAL_WEATHER: '4',
  MARINE_FORECAST: '10',
  SST: '7',
  RADAR_WIND: '8',
  SATELLITE_WIND: '9',
  ONSITE_REPORTS: '12',
  SURFACE_CURRENTS: '13',
  WATER_LEVEL: '14',
  FLOWVIZ: '18',
  STORMPRINT_TIMESERIES: '14',
  STORMPRINT_MAXWINDS: '15',
  STORMPRINT_TIMESERIES_ADJUSTED: '16',
  STORMPRINT_MAXWINDS_ADJUSTED: '17',
  WIND_GUST: '19',
  RADAR_GUST: '20',
  LIGHTNING: '21',
  WATCHES_WARNINGS: '22',
  WIND_RADAR_SATELLITE: '23',
  WET_BULB_GLOBE_TEMPERATURE: '24',
  PRECIP_ACCUMULATION: '25',
  DSAT_OPERATING_CONDITION: '100',
  TEMPERATURE_FORECAST: '101',
  PRESSURE_FORECAST: '102',
  NAUTICAL_CHARTS_WIND: '103',
  FAVORITE_SPOTS: '104',
  LIVE_WIND: '105',
  HUMIDITY_FORECAST: '106',
  CUSTOM_TEXT: 'custom-text',
  CUSTOM_OVERLAY: 'custom-overlay'
}